import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5667260c")

_pushScopeId("data-v-5667260c")
const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "scorecards-kpi-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.scorecardsKpiDialogDescriptor.style.dialog,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.kpi')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withId(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.save
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withId(() => [
      _createVNode(_component_DataTable, {
        value: _ctx.kpis,
        paginator: _ctx.kpis.length > 20,
        rows: 20,
        class: "p-datatable-sm kn-table p-p-2",
        selection: _ctx.selected,
        "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selected = $event)),
        dataKey: "id",
        filters: _ctx.filters,
        "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
        globalFilterFields: _ctx.scorecardsKpiDialogDescriptor.globalFilterFields,
        scrollable: true,
        scrollHeight: _ctx.scorecardsKpiDialogDescriptor.style.dialog.scrollHeight
      }, {
        header: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                placeholder: _ctx.$t('common.search')
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ])
        ]),
        empty: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        default: _withId(() => [
          _createVNode(_component_Column, {
            selectionMode: "multiple",
            headerStyle: _ctx.scorecardsKpiDialogDescriptor.selectColumnStyle
          }, null, 8, ["headerStyle"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "status",
            header: _ctx.$t('common.status'),
            sortable: true
          }, {
            body: _withId((slotProps) => [
              _createVNode("i", {
                class: ["fas fa-square fa-2xl p-mr-2", _ctx.getKpiIconColorClass(slotProps.data)]
              }, null, 2)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "name",
            header: _ctx.$t('common.name'),
            sortable: true
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "category.valueName",
            header: _ctx.$t('common.category'),
            sortable: true
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "creationDate",
            header: _ctx.$t('common.creationDate'),
            sortable: true
          }, {
            body: _withId((slotProps) => [
              _createVNode("span", null, _toDisplayString(_ctx.getFormattedDate(slotProps.data.creationDate)), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            class: "kn-truncated",
            field: "author",
            header: _ctx.$t('common.author'),
            sortable: true
          }, null, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value", "paginator", "selection", "filters", "globalFilterFields", "scrollHeight"])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
})